<div>
  <p class="showLineBreaks"> 
    {{newVerbiage}}
  </p>
</div>
